import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Map } from 'immutable';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { unwrap } from '../../../../utils/ChangeSpy';
import { GridRow } from '../GridRow';
import { Spinner } from '../../../helpers/Spinner';

import style from './style.module.css';

const drawBL = (backloggedActivities, action, onClick) => {
  const backloggedActivitiesList = backloggedActivities.map(activity => activity.get('value')).toJS();
  const showBL =
    (action.get('isLetter') || action.get('isEmail')) &&
    backloggedActivitiesList.includes(unwrap(action.get('activity')));

  if (!showBL) {
    return null;
  }

  const spinner = action.get('spinner');
  const backlogged = action.get('backlogged');
  const id = action.get('id');

  if (spinner) {
    return (
      <a className={classNames(style.backlogButton, 'btn btn-primary btn-xs')}>
        <Spinner size="small" inline />
      </a>
    );
  }

  return (
    <a
      className={classNames(style.backlogButton, 'btn btn-primary btn-xs')}
      onClick={event => onClick({ event, id, backlogged })}
    >
      BL
    </a>
  );
};

/**
 * Stateless component for a target next action row.
 *
 * @param props {Object}.
 * @param props.action {Immutable.Map} Next action row.
 * @param props.index {Number} Row number.
 * @param props.onClick {Function} Handle setting backlogged.
 * @param props.onRowSelected {function} To handle checkbox change event.
 */
const TargetRowComponent = ({ action, index, backloggedActivities, onRowSelected, onClick }) => {
  const actionId = action.get('id');
  const blClassName = classNames({ [style.backlogged]: action.get('backlogged') });
  const project = (
    <span
      className={classNames({
        'text-uppercase text-danger text-bold': !action.get('projectId'),
      })}
    >
      {action.get('projectName')}
    </span>
  );
  const buyer = (
    <span
      className={classNames({
        'text-uppercase text-danger text-bold': !action.get('buyerId'),
      })}
    >
      {action.get('buyerName')}
    </span>
  );

  const bl = drawBL(backloggedActivities, action, onClick);
  const checked = action.get('selected', false);
  const date = action.get('date');
  const userName = action.get('userName');
  const secondUserName = (
    <div>
      {action.get('recordOwnerUserName')}
      <br />
      {action.get('recordSubOwnerUserName')}
    </div>
  );
  const activity = action.get('activity');
  const linkTo = `/company/${action.get('targetId')}`;
  const legalName = action.get('legalName');
  const currentStatus = action.get('currentStatus');
  const highStatus = action.get('highStatus');
  const priority = action.get('priority');
  const entityType = action.get('entityType');
  const targetRevenue = action.get('targetRevenue');
  const targetEmployees = action.get('targetEmployees');
  const address = action.get('address');
  const web = action.get('web');
  const webLink = action.get('webLink');
  const industryLabel = action.get('industryLabel');

  return (
    <GridRow action={action} className={blClassName}>
      <td>{index}</td>
      <td>
        <input checked={checked} name="selected" onChange={onRowSelected} type="checkbox" value={actionId} />
      </td>
      <td>{date}</td>
      <td>{userName}</td>
      <td>{secondUserName}</td>
      <td>{activity}</td>
      <td>{bl}</td>
      <td>
        <Link target="_blank" to={linkTo}>
          {legalName}
        </Link>
      </td>
      <td>
        <strong>{currentStatus}</strong>&nbsp;/&nbsp;{highStatus}
      </td>
      <td className="text-uppercase">{priority}</td>
      <td colSpan="2">{entityType}</td>
      <td>{targetRevenue}</td>
      <td>{targetEmployees}</td>
      <td>{address}</td>
      <td>
        <a href={webLink} rel="noopener noreferrer" target="_blank">
          {web}
        </a>
      </td>
      <td>
        {buyer} - {project}
      </td>
      <td>{industryLabel}</td>
    </GridRow>
  );
};

TargetRowComponent.propTypes = {
  action: PropTypes.instanceOf(Map).isRequired,
  index: PropTypes.number,
  onClick: PropTypes.func,
  onRowSelected: PropTypes.func.isRequired,
};

export const TargetRow = memo(TargetRowComponent);
